// extracted by mini-css-extract-plugin
export var container = "TrustElements-module--container--2Y25l";
export var content = "TrustElements-module--content--8t38G";
export var elementsList = "TrustElements-module--elementsList--2xdO-";